var _defs, _rect, _rect2, _tspan, _rect3, _rect4, _tspan2, _rect5, _rect6, _g, _rect7, _rect8, _g2, _rect9, _rect10, _rect11, _path, _path2, _g3, _g4, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _tspan3, _g5, _g6, _rect19, _rect20, _rect21, _g7, _g8, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormAbstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500pt",
    height: "300pt",
    viewBox: "0 0 500 300",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter28",
    x: -0.25264,
    y: -0.16077,
    width: 1.5468,
    height: 1.348,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.49804,
    in: "SourceGraphic",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.652,
    y: 0.49217,
    width: 104.99,
    height: 78.391,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#fff",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.45518
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.496 0 0 3.496 83.545 .075022)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.652,
    y: 0.46309,
    width: 104.99,
    height: 78.449,
    rx: 0.42906,
    ry: 0.42906,
    fill: "#fff",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.39702
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.772,
    y: 2.5519,
    width: 29.493,
    height: 19.273,
    rx: 0.42906,
    ry: 0.42906,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), /*#__PURE__*/React.createElement("text", {
    x: 24.91313,
    y: 15.907614,
    fill: "#0100ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "5.0232px",
    strokeMiterlimit: 10,
    strokeWidth: 0.3588,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 24.91313,
    y: 15.907614,
    fill: "#0100ff",
    strokeWidth: 0.3588
  }, "$17M"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 4.1012,
    width: 14.295,
    height: 2.8704,
    rx: 0.85813,
    ry: 0.85813,
    fill: "#8080ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51.399,
    y: 2.5519,
    width: 29.493,
    height: 19.273,
    rx: 0.42906,
    ry: 0.42906,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), /*#__PURE__*/React.createElement("text", {
    x: 60.789692,
    y: 15.907614,
    fill: "#0100ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "5.0232px",
    strokeMiterlimit: 10,
    strokeWidth: 0.3588,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 60.789692,
    y: 15.907614,
    fill: "#0100ff",
    strokeWidth: 0.3588
  }, "184"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53.137,
    y: 4.1012,
    width: 14.295,
    height: 2.8704,
    rx: 0.85813,
    ry: 0.85813,
    fill: "#8080ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86.026,
    y: 2.5519,
    width: 29.493,
    height: 19.273,
    rx: 0.42906,
    ry: 0.42906,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0064725 -.0095958 .0095958 .0064725 90.965 15.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m534.37 632.86v-483.28c0.28125-10.406-9.3281-19.125-19.734-18.422-246.52 18.047-439.64 225.89-439.64 473.34-4.4062 352.64 388.26 588.84 697.22 419.34 9.4219-4.7344 12.797-17.719 6.6094-26.531l-244.5-364.45z",
    fill: "#5252ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1122.1 699.37c-2.9531-4.5938-7.7344-7.5469-13.078-8.2969l-477.42-66.141c-15.984-2.8125-27.562 17.391-16.969 29.672l285.24 358.92c5.9062 7.4062 16.5 9.2812 24.328 4.0312 100.03-63.375 170.26-202.87 199.92-303.1 1.6406-4.9688 0.75-10.688-2.0156-15.094z",
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m610.82 578.16h421.22c10.547 0.1875 19.359-9.4219 18.422-19.922-16.969-232.74-205.26-421.22-438.14-438.14-10.312-0.70312-20.109 7.875-19.922 18.422v421.22c0 10.125 8.2969 18.422 18.422 18.422z",
    fill: "#4e35b0"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87.686,
    y: 4.1012,
    width: 14.295,
    height: 2.8704,
    rx: 0.85813,
    ry: 0.85813,
    fill: "#8080ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86.026,
    y: 25.862,
    width: 29.493,
    height: 19.273,
    rx: 0.42906,
    ry: 0.42906,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.29336 -.514 0 126.84 67.531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.352 73.08h-5.4667v-24.173h5.467l-1.19e-4 24.173z",
    fill: "#b3b3ff",
    strokeWidth: 0.032876
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.331 73.08h-5.467v-18.762l5.467 1.58e-4z",
    fill: "#6766ff",
    strokeWidth: 0.032876
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.4 73.08h-5.467v-28.16h5.467z",
    fill: "#8080ff",
    strokeWidth: 0.032705
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.37 73.08h-5.4667v-32.072h5.4667z",
    fill: "#33f",
    strokeWidth: 0.032876
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 87.686,
    y: 27.411,
    width: 14.295,
    height: 2.8704,
    rx: 0.85813,
    ry: 0.85813,
    fill: "#8080ff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 86.026,
    y: 48.702,
    width: 29.493,
    height: 19.273,
    rx: 0.42906,
    ry: 0.42906,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 87.686,
    y: 50.251,
    width: 14.295,
    height: 2.8704,
    rx: 0.85813,
    ry: 0.85813,
    fill: "#8080ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m89.165 65.506 4.569-6.5719 7.0727 3.938 4.8461-3.5639 6.8772-2.9987",
    fill: "none",
    stroke: "#8ecb86",
    strokeMiterlimit: 10,
    strokeWidth: 0.45518
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m89.006 63.092h4.9352l6.8652-4.4139 4.9888 2.148 6.6265-7.3894",
    fill: "none",
    stroke: "#2680d9",
    strokeMiterlimit: 10,
    strokeWidth: 0.45518
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.4351)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(0 -1.4351)",
    x: 16.772,
    y: 25.862,
    width: 64.171,
    height: 42.162,
    rx: 0.42906,
    ry: 0.42906,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.4351)",
    fill: "none",
    stroke: "#94b3d1",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.846 37.74v24.268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.345 37.74v24.268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.843 37.74v24.268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.334 57.348 49.757-3.9e-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.334 52.454 49.757-3.8e-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.334 47.559 49.757-3.8e-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.334 42.651 49.757-3.8e-5"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 24.334,
    y: 37.74,
    width: 49.757,
    height: 24.268,
    rx: 0.42906,
    ry: 0.42906,
    strokeWidth: 0.24972
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 25.976,
    width: 14.295,
    height: 2.8704,
    rx: 0.85813,
    ry: 0.85813,
    fill: "#8080ff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.772,
    y: 71.583,
    width: 29.493,
    height: 19.273,
    rx: 0.42906,
    ry: 0.42906,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.51,
    y: 73.132,
    width: 14.295,
    height: 2.8704,
    rx: 0.85813,
    ry: 0.85813,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.399,
    y: 71.583,
    width: 29.493,
    height: 19.273,
    rx: 0.42906,
    ry: 0.42906,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.137,
    y: 73.132,
    width: 14.295,
    height: 2.8704,
    rx: 0.85813,
    ry: 0.85813,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.026,
    y: 71.583,
    width: 29.493,
    height: 19.273,
    rx: 0.42906,
    ry: 0.42906,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.686,
    y: 73.132,
    width: 14.295,
    height: 2.8704,
    rx: 0.85813,
    ry: 0.85813,
    fill: "#8080ff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3796 0 0 1.3796 150 1.7247)"
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -107.51,
    y: 46.988,
    width: 225,
    height: 168,
    rx: 1.0873,
    ry: 1.0873,
    fill: "#fff",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.9755
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 27.734,
    y: 63.625,
    width: 41.25,
    height: 8.25,
    rx: 1.0873,
    ry: 1.0873,
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 12.943,
    y: 62.077,
    width: 10.9,
    height: 10.9,
    rx: 1.0873,
    ry: 1.0873,
    fill: "none",
    stopColor: "#000000",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.94848,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 12.853,
    y: 51.727,
    width: 90,
    height: 7.5,
    rx: 1.0873,
    ry: 1.0873,
    fill: "#339cff"
  })), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: -60.053,
    y: 92.626,
    width: 52.5,
    height: 12.709,
    rx: 1.0873,
    ry: 1.0873,
    fill: "none",
    stroke: "#babfc3",
    strokeWidth: 0.94848
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: -54.353489,
    y: 101.67973,
    fill: "#babfc3",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "8.7795px",
    letterSpacing: ".9755px",
    strokeWidth: 0.96672,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----"), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 9.3854,
    y: 92.626,
    width: 52.5,
    height: 12.709,
    rx: 1.0873,
    ry: 1.0873,
    fill: "none",
    stroke: "#babfc3",
    strokeWidth: 0.94848
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 15.084666,
    y: 101.67973,
    fill: "#babfc3",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "8.7795px",
    letterSpacing: ".9755px",
    strokeWidth: 0.96672,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: -60.249,
    y: 81.727,
    width: 45,
    height: 7.5,
    rx: 1.0873,
    ry: 1.0873,
    fill: "#339cff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -60.173,
    y: 62.626,
    width: 60,
    height: 12.709,
    rx: 1.0873,
    ry: 1.0873,
    fill: "none",
    stopColor: "#000000",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.94848,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: -60.647,
    y: 51.727,
    width: 33.75,
    height: 7.5,
    rx: 1.0873,
    ry: 1.0873,
    fill: "#339cff"
  })), /*#__PURE__*/React.createElement("text", {
    x: -2.5261581,
    y: 101.33878,
    fill: "#392781",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "7.5px",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: -2.5261581,
    y: 101.33878,
    fill: "#cccccc",
    fontSize: "7.5px",
    strokeWidth: 0.75
  }, "to"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9826 0 0 2.256 -91.18 62.204)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.4425,
    y: 21.22,
    width: 107.9,
    height: 44.598,
    rx: 1.0968,
    ry: 0.9639,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5.4425 29.157h107.76",
    fill: "none",
    stroke: "#3d4193",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -3.2969,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#0100ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 31.274,
    width: 19.844,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#6766ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 31.274,
    width: 21.167,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ffcb66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 31.274,
    width: 22.49,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#f66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#33f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ffba33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#f33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#4c4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 48.712,
    width: 21.167,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#0200ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ffd480"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 54.525,
    width: 17.198,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#4d4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 60.338,
    width: 19.844,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 31.274,
    width: 19.981,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#8976d5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 37.087,
    width: 19.937,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#452f9d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 42.899,
    width: 16.778,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#7862d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 48.712,
    width: 21.985,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 54.525,
    width: 19.547,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#9b8adb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 60.338,
    width: 17.574,
    height: 3.9688,
    rx: 1.5796,
    ry: 1.3883,
    fill: "#7862d0"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.033633 0 0 .033633 -105.49 47.599)",
    fill: "#3d4193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m878.91 798.85v199.64h-519.64v-754.55h160.24v39.516h199.15v-39.516h160.24v80.363c7.6367-0.72656 15.395-1.0898 23.152-1.0898 5.6953 0 11.395 0 16.969 0.60547v-119.88h-600v834.55h600v-239.15c-5.5742 0-11.273 0.72656-16.969 0.72656-7.7578 4e-3 -15.516-0.48438-23.152-1.2109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.03 402.73v-79.516h-120v119.15h120zm-40 0h-40v-39.758h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.03 641.03v-79.516h-120v119.15h120zm-40 0h-40v-39.637h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m978.06 463.33-141.46 140.36-56.484-56.121-28.363 28.121 56.605 56.121 28.242 28.121 28.363-28.121 141.46-140.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.03 800.06h-40v119.15h120v-119.15zm40 79.395h-40v-39.152h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619.03 184.67c5.1367-4e-3 10.07 1.9961 13.762 5.5703 3.6875 3.5742 5.8359 8.4453 5.9961 13.578h40c-0.9375-20.773-12.559-39.582-30.723-49.707s-40.273-10.125-58.438 0c-18.16 10.125-29.785 28.934-30.719 49.707h40.242c0.125-5.1641 2.2852-10.07 6.0039-13.656 3.7227-3.5859 8.707-5.5586 13.875-5.4922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.03 362.97c-52.633 0.28906-103 21.453-140.04 58.844s-57.734 87.953-57.531 140.59c0.20312 52.633 21.285 103.04 58.613 140.14 37.332 37.105 87.859 57.879 140.49 57.762 52.633-0.11719 103.07-21.117 140.23-58.387 37.164-37.27 58.023-87.766 57.992-140.4-0.2266-52.801-21.383-103.35-58.832-140.57-37.445-37.219-88.129-58.07-140.93-57.973zm0 357.33v4e-3c-42.051-0.28906-82.266-17.246-111.83-47.148-29.562-29.906-46.055-70.312-45.863-112.36 0.19141-42.051 17.055-82.305 46.891-111.94 29.836-29.633 70.207-46.219 112.25-46.125 42.051 0.0976 82.348 16.867 112.05 46.637 29.699 29.766 46.379 70.098 46.383 112.15-0.1602 42.254-17.094 82.711-47.07 112.49-29.98 29.773-70.555 46.43-112.81 46.301z"
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 91.824,
    y: 63.625,
    width: 21,
    height: 8.25,
    rx: 1.0873,
    ry: 1.0873,
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 77.033,
    y: 62.077,
    width: 10.9,
    height: 10.9,
    rx: 1.0873,
    ry: 1.0873,
    fill: "none",
    stopColor: "#000000",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.94848,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: -99.442,
    y: 88.401,
    width: 33.75,
    height: 10.5,
    rx: 1.6309,
    ry: 1.6309,
    fill: "#3d4193"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.8346 0 0 2.8346 103.41 23.622)",
    filter: "url(#filter28)"
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 28.212,
    y: 2.0242,
    width: 48.179,
    height: 75.71,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#f9f8fd",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 0.34414
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "submit",
    transform: "matrix(1.3007 0 0 1.3007 -2.2456 -3.301)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.817,
    y: 54.894,
    width: 19.012,
    height: 5.5571,
    rx: 0.40684,
    ry: 0.40684,
    fill: "#0200ff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "upload-i",
    transform: "matrix(.0075316 0 0 .0075316 46.985 55.622)",
    fill: "#f210ef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m798.01 421.41-169.74-169.69c-15.625-15.625-40.969-15.625-56.555 0l-169.73 169.69 56.605 56.555 101.41-101.4v423.43h79.992v-423.43l101.45 101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m880 720v160.01h-559.99v-160.01h-80.004v160.01c0 43.98 36.012 79.992 80.004 79.992h559.99c43.992 0 80.004-36.012 80.004-79.992v-160.01z"
  }))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 51.575,
    width: 13.229,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffc34c"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.52,
    y: 55.35,
    width: 43.735,
    height: 9.3218,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#fa9ef9",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 35.723,
    y: 45.902,
    width: 18.521,
    height: 2.9104,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#46991f"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.505,
    y: 45.355,
    width: 3.8452,
    height: 3.8452,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#46991f",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 41.704,
    width: 31.75,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffc34c"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 30.53,
    y: 34.712,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ff5252",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 31.810261,
    y: 38.079994,
    fill: "#babfc3",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.0972px",
    letterSpacing: ".34414px",
    strokeMiterlimit: 10,
    strokeWidth: 0.34104,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----"), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 30.473,
    y: 31.242,
    width: 15.875,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffc34c"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.53,
    y: 24.388,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#5352ff",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 20.78,
    width: 11.906,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffc34c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3d4193"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 16.306,
    width: 31.66,
    height: 2.409,
    rx: 0.52917,
    ry: 0.52917,
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 13.209,
    width: 44.049,
    height: 2.409,
    rx: 0.52917,
    ry: 0.52917,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.363,
    y: 10.111,
    width: 44.049,
    height: 2.409,
    rx: 0.52917,
    ry: 0.52917,
    stopColor: "#000000",
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 40.546,
    y: 4.9541,
    width: 23.683,
    height: 3.7042,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#241c56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormAbstract);
export default __webpack_public_path__ + "static/media/form-abstract.3e91dbc788509295117cba086919a750.svg";
export { ForwardRef as ReactComponent };